import { isObject } from 'lodash';
import api from '../../../utils/api';
import { escapeSpecialChars } from '../../../utils/textHelper';

let getPricingAbortController;
export function getPricing(supplierId, params) {
  if (getPricingAbortController) getPricingAbortController.abort();
  getPricingAbortController = new AbortController();

  if (isObject(params.filters)) {
    params.filters.search = escapeSpecialChars(params.filters.search);
    params.filters = JSON.stringify(params.filters);
  }

  const queryParams = new URLSearchParams(params);
  return api.get(`/suppliers/${supplierId}/pricing?${queryParams}`, { signal: getPricingAbortController.signal });
}

export function exportPricing(supplierId, options) {
  return api.post(`/suppliers/${supplierId}/export-pricing-report`, options);
}

export function uploadPricingFile(supplierId, payload) {
  return api.post(`/suppliers/${supplierId}/pricing/upload`, payload);
}
